import { createHttpActions } from '@next/arable-lib/shared';
import { createAction } from '@ngrx/store';

import { Feature, SoilAnalysis } from '../map.models';

export const refreshPageRequest = createAction(
  '[Map] Refresh Page',
);

export const upsertFeatures = createAction(
  '[Map] Upsert features',
  (features: Feature[]) => ({ features }),
);

export const setSoilAnalysesLayerEnabled = createAction(
  '[Map] Set Soil analyses layer enabled',
  (enabled: boolean) => ({ enabled }),
);

export const setBlightLayerEnabled = createAction(
  '[Map] Set Blight layer enabled',
  (enabled: boolean) => ({ enabled }),
);

export const setCropFieldsLayerEnabled = createAction(
  '[Map] Set Crop Fields layer enabled',
  (enabled: boolean) => ({ enabled }),
);

export const [
  loadSoilAnalysis,
  loadSoilAnalysisSuccess,
  loadSoilAnalysisFailed,
] = createHttpActions<void, { soilAnalyses: SoilAnalysis[] }, { message: string }>('Load Soil Analysis');
